import type { ReactNode } from 'react';

import { BrowserRouter } from 'react-router-dom';

interface RouterProviderProps {
  children: ReactNode;
}

/** Provides client-side routing via React Router's `BrowserRouter`. */
export function RouterProvider({ children }: RouterProviderProps) {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {children}
    </BrowserRouter>
  );
}
